import styled from "styled-components";

export const MainModel = styled.div``;

export const ModelsData = styled.div`
  .main-div {
    position: relative;
    width: 100%;
    min-height: 461.3px;
  }

  .modal-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .content-div {
    position: relative;

    h1 {
      font-size: 36px;
      font-style: italic;
      font-weight: 400;
      line-height: 43px;
      letter-spacing: 0em;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      margin-top: 3rem;

      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }

  .img-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    h5 {
      font-size: 24px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: 0.14em;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      margin-top: 0.5rem;
    }
  }

  .img-wrapper {
    display: flex;
    align-items: center;
    gap: 7rem;
    justify-content: center;
    margin-top: 4rem;

    @media (max-width: 990px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      margin-top: 2rem;
      padding-bottom: 2rem;
    }
  }

  .icon {
    display: flex;
    justify-content: end;
    align-items: end;
    padding: 0.9rem 1rem 0rem 0rem;
    cursor: pointer;
  }
`;

export const ConnectButton = styled.button`
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
  border-radius: 30px;
  width: 360px;
  height: 110px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  border: none;
  font-weight: 700;
  font-size: 19px;
  @media (max-width: 767px) {
    width: 100px;
  }
`;

export const ConnectIcon = styled.img`
  width: 60px;
  margin-right: 1rem;
`;

export const Text = styled.p`
  font-family: "Inter";
  font-size: 2.26231rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: linear-gradient(
    180deg,
    rgba(224, 197, 40, 0.3) 0%,
    rgba(247, 193, 58, 0.3) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0rem;

  @media (max-width: 767px) {
    font-size: 1.5rem;
  }
`;

export const MainDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
  border: 1.186px solid rgba(17, 17, 17, 0.5);
  width: 460.352px;
  height: 80.68px;
  cursor: pointer;
  padding: 0rem 2rem;

  @media (max-width: 767px) {
    width: 100%;
  }
  .imgs {
    width: 48.645px;
    height: 45.086px;
    object-fit: contain;
  }

  h5 {
    color: rgba(0, 0, 0, 0.6);
    font-size: 33.601px;
    font-style: normal;
    font-weight: 700;
    line-height: 47.041px; /* 140% */
    letter-spacing: -0.521px;
    text-transform: uppercase;
    margin-bottom: 0rem;

    @media (max-width: 767px) {
      font-size: 1.2rem;
    }
  }

  &:hover {
    background: #111;

    h5 {
      color: #ffbe53;
    }
  }
`;

export const Title = styled.h5`
  color: #fff;
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 4.82794rem; /* 193.117% */
  letter-spacing: -0.05rem;

  span {
    background: var(
      --yellow,
      linear-gradient(180deg, #e0c528 0%, #f7c13a 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 2.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: 4.82794rem;
    letter-spacing: -0.05rem;
  }
`;
